import { render, staticRenderFns } from "./classOrder.vue?vue&type=template&id=240ffe0a&scoped=true"
import script from "./classOrder.vue?vue&type=script&lang=js"
export * from "./classOrder.vue?vue&type=script&lang=js"
import style0 from "./classOrder.vue?vue&type=style&index=0&id=240ffe0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240ffe0a",
  null
  
)

export default component.exports